import { render } from "./product-card-sawmill.vue?vue&type=template&id=78bd2f6c"
import script from "./product-card-sawmill.vue?vue&type=script&lang=js"
export * from "./product-card-sawmill.vue?vue&type=script&lang=js"

import "./product-card-sawmill.vue?vue&type=style&index=0&id=78bd2f6c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__